/* Saved items (wishlist) stored in localStorage. Exposes window.BrownSaved and
   makes every [data-save-toggle][data-handle] element clickable. */
(function () {
  var KEY = 'ba_saved';
  var listeners = [];

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable, keep in memory only */
    }
    memory = list;
    sync();
    document.dispatchEvent(new CustomEvent('saved:changed', { detail: { handles: list.slice() } }));
  }

  var memory = read();

  var api = {
    list: function () { return memory.slice(); },
    has: function (handle) { return memory.indexOf(handle) !== -1; },
    add: function (handle) {
      if (!handle || api.has(handle)) return;
      write(memory.concat([handle]));
    },
    remove: function (handle) {
      if (!api.has(handle)) return;
      write(memory.filter(function (h) { return h !== handle; }));
    },
    toggle: function (handle) {
      if (api.has(handle)) api.remove(handle); else api.add(handle);
      return api.has(handle);
    },
    sync: sync
  };

  function sync() {
    var toggles = document.querySelectorAll('[data-save-toggle][data-handle]');
    for (var i = 0; i < toggles.length; i++) {
      var el = toggles[i];
      var on = api.has(el.getAttribute('data-handle'));
      el.classList.toggle('is-saved', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? el.getAttribute('data-label-saved') : el.getAttribute('data-label-save');
      if (label) el.setAttribute('aria-label', label);
    }
    var counts = document.querySelectorAll('[data-saved-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = memory.length;
      counts[j].hidden = memory.length === 0;
    }
    document.documentElement.classList.toggle('has-saved', memory.length > 0);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-save-toggle][data-handle]');
    if (!toggle) return;
    event.preventDefault();
    event.stopPropagation();
    api.toggle(toggle.getAttribute('data-handle'));
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var toggle = event.target.closest('[data-save-toggle][data-handle]');
    if (!toggle || toggle.tagName === 'BUTTON') return;
    event.preventDefault();
    api.toggle(toggle.getAttribute('data-handle'));
  });

  window.addEventListener('storage', function (event) {
    if (event.key === KEY) {
      memory = read();
      sync();
      document.dispatchEvent(new CustomEvent('saved:changed', { detail: { handles: memory.slice() } }));
    }
  });

  var pending = null;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = window.requestAnimationFrame(function () {
      pending = null;
      sync();
    });
  });

  function start() {
    sync();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.BrownSaved = api;
})();
